import { useRef, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { TrashIcon } from '@i-ark/components';
import '@i-ark/models';
import '@utils/component-framework';
import { useDeleteLineEntryMutation } from '../../../state/mutations/entries/line.delete.js';
import '@tanstack/react-query';
import { iArkStore } from '../../../state/store.js';
import { useShortcut } from '../../hook.use-shortcut.js';
import { useUserOwnsEntry } from '../../hook.user-owns-entry.js';
import { buttonCls, FADE_TRANSITION_DURATION } from './Line.style.js';
import { jsx } from 'react/jsx-runtime';

const Line = ({
  pageId,
  item,
  isSelected
}) => {
  const entryKey = iArkStore.useSelector(state => state.entryKey);
  const ref = useRef(null);
  const deleteLineMutation = useDeleteLineEntryMutation(entryKey);
  const userOwnsEntry = useUserOwnsEntry(entryKey);
  const enableSelection = isSelected && userOwnsEntry;
  const handleDelete = () => {
    deleteLineMutation({
      pageId,
      lineId: item.id
    });
  };
  useShortcut("Backspace", enableSelection ? handleDelete : undefined);
  useShortcut("Delete", enableSelection ? handleDelete : undefined);

  // prevent event propagation when user touches the delete button, as it would
  // otherwise simply initiate a drag'n'drop session to move the line around
  useEffect(() => {
    const node = ref.current;
    if (node === null) {
      return;
    }
    const handlePreventPropagation = evt => {
      evt.stopImmediatePropagation();
    };
    node.addEventListener("mousedown", handlePreventPropagation);
    node.addEventListener("touchstart", handlePreventPropagation);
    return () => {
      node.removeEventListener("mousedown", handlePreventPropagation);
      node.removeEventListener("touchstart", handlePreventPropagation);
    };
  }, [enableSelection]);
  return /*#__PURE__*/jsx(CSSTransition, {
    in: enableSelection,
    classNames: buttonCls,
    timeout: FADE_TRANSITION_DURATION,
    mountOnEnter: true,
    unmountOnExit: true,
    nodeRef: ref,
    children: /*#__PURE__*/jsx("button", {
      ref: ref,
      className: buttonCls,
      onClick: handleDelete,
      onMouseDownCapture: evt => {
        evt.stopPropagation();
      },
      onTouchStartCapture: evt => {
        evt.stopPropagation();
      },
      children: /*#__PURE__*/jsx(TrashIcon, {
        size: 10
      })
    })
  });
};

export { Line };
//# sourceMappingURL=Line.js.map
